import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import ReactPaginate from "react-paginate";
import queryString from "query-string";

import Spinner from "../../components/generics/Spinner";
import ReportHeader from "../../components/generics/ReportHeader";
import Filter from "../../components/generics/Filter";
import ReceivingList from "../../components/reports/ReceivingList";

import { fetchVendors, fetchVendorsSuccess, fetchVendorsFailure } from "../../store/invoices/actions";
import { fetchReceivingReport, fetchReceivingReportSuccess, fetchReceivingReportFailure } from "../../store/reports/actions";

import { fetchReceivingReportCSV, getReceivingReportPdf } from "../../store/reports/api";

import { STARTING_PAGE, DEBOUNCE_SEARCH } from "../../constants/constants";
import { withRouter } from "utils/WithRouter";

export class ReportReceivingContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      vendor: undefined,
      date: "",
      lot: "",
    };

    this.changeSearch = _.debounce(() => {
      this.updateResults();
    }, DEBOUNCE_SEARCH);
  }

  componentDidMount() {
    if (!this.props.vendorsList.vendors || this.props.vendorsList.vendors.length === 0) {
      this.props.fetchVendors();
    }
    const params = queryString.parse(this.props.location.search);
    const page = params.page ? params.page : STARTING_PAGE;
    const date = params.date ? params.date : "";
    const vendor = params.vendor ? params.vendor : undefined;
    const lot = params.lot ? params.lot : this.state.lot;

    this.setState({ page, date, vendor, lot }, () => {
      this.props.fetchReceivingReport(page, date, vendor, lot);
    });
  }

  updateResults = () => {
    const { page, date, vendor, lot } = this.state;
    let params = {};
    params.page = page;
    if (date) params.date = date;
    if (vendor) params.vendor = vendor;
    if (lot) params.lot = lot;
    this.props.history.push({ search: queryString.stringify(params) });
    this.props.fetchReceivingReport(page, date, vendor, lot);
  };

  onVendorChange = (event) => {
    const vendor = event.target.value && event.target.value > -1 ? event.target.value : undefined;
    this.setState({ vendor, page: STARTING_PAGE }, () => {
      this.changeSearch();
    });
  };

  onDateChange = (event) => {
    const date = event.target.value ? event.target.value : "";
    this.setState({ date, page: STARTING_PAGE }, () => {
      this.changeSearch();
    });
  };

  onLotChange = (event) => {
    const lot = event.target.value ? event.target.value : "";
    this.setState({ lot }, () => {
      this.changeSearch();
    });
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    const page = data.selected + 1;
    if (page !== this.state.page) {
      this.setState({ page }, () => {
        this.changeSearch();
      });
    }
  };

  loadCsv = () => {
    const { date, vendor, lot } = this.state;
    const fileName = `ReceivingReport.csv`;
    this.setState({
      csvIsLoading: true,
    });
    fetchReceivingReportCSV(date, vendor, lot)
      .then((r) => {
        const blob = new Blob([r.data], { type: "text/csv" });
        let link = document.createElement("a");
        document.body.appendChild(link);
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", fileName);
        link.click();
        document.body.removeChild(link);
        this.setState({
          csvIsLoading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          csvIsLoading: false,
        });
      });
  };

  setPrint() {
    this.contentWindow.__container__ = this;
    this.contentWindow.onbeforeunload = () => document.body.removeChild(this.__container__);
    this.contentWindow.onafterprint = () => document.body.removeChild(this.__container__);
    this.contentWindow.focus(); // Required for IE
    this.contentWindow.print();
  }

  printPdf = () => {
    const { date, vendor, lot } = this.state;
    this.setState({
      pdfIsLoading: true,
    });
    getReceivingReportPdf(date, vendor, lot)
      .then((r) => {
        let blob = new Blob([r.data], { type: "application/pdf" });
        const oHideFrame = document.createElement("iframe");
        oHideFrame.style.display = "none";
        oHideFrame.onload = this.setPrint;
        oHideFrame.src = window.URL.createObjectURL(blob);
        document.body.appendChild(oHideFrame);

        this.setState({
          pdfIsLoading: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          pdfIsLoading: false,
        });
      });
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    if (!this.props.receivingReport.receivingReports) {
      return <Spinner />;
    } else {
      return (
        <div className="animated fadeIn">
          <div className="card">
            <ReportHeader
              title="Receiving purchase orders"
              actionClass="btn btn-primary m-0"
              actionTitle="Export CSV"
              csvLoading={this.state.csvIsLoading}
              fromFile={true}
              loadCsv={this.loadCsv}
              showPdfButton
              actionClass2="btn btn-primary m-0 ml-1"
              actionTitle2="Print PDF"
              pdfLoading={this.state.pdfIsLoading}
              printPdf={this.printPdf}
            />
            <Filter
              dateLabel="Invoice Date"
              dateVal={this.state.date}
              onDateChange={this.onDateChange}
              dropdownPlaceholder="Select vendor"
              dropdownLabel="Vendors"
              dropdownVal={this.state.vendor}
              onDropdownChange={this.onVendorChange}
              dropdownByElementId
              dropdownOptions={this.props.vendorsList.vendors.results}
              searchLabel3="Lot"
              searchPlaceholder3="Search by lot"
              searchVal3={this.state.lot}
              onSearchChange3={this.onLotChange}
            />
          </div>

          <div className="card">
            <div className="card-block p-0">
              <table className="table table-striped table-bordered datatable mb-0">
                <thead>
                  <tr>
                    <th>Vendor</th>
                    <th>
                      <span className="hidden-lg-down">Invoice Number</span>
                      <span className="hidden-xl-up">Inv. Number</span>
                    </th>
                    <th>
                      <span className="hidden-lg-down">Invoice Date</span>
                      <span className="hidden-xl-up">Inv. Date</span>
                    </th>
                    <th>Item</th>
                    <th>Brand</th>
                    <th>Grade</th>
                    <th>Lot</th>
                    <th>
                      <span className="hidden-lg-down">Packing Date</span>
                      <span className="hidden-xl-up">Pack Date</span>
                    </th>
                    <th>Weight</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <ReceivingList reports={this.props.receivingReport.receivingReports} />
              </table>
              {this.props.receivingReport.pages > 1 && (
                <ReactPaginate
                  pageCount={this.props.receivingReport.pages}
                  pageRangeDisplayed={2}
                  marginPagesDisplayed={1}
                  previousLabel="<"
                  nextLabel=">"
                  onPageChange={this.handlePageRequest}
                  initialPage={this.state.page - 1}
                  disableInitialCallback={true}
                  containerClassName="pagination"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  activeClassName="page-item active"
                  previousClassName="paginate_button previous"
                  nextClassName="paginate_button next"
                  disabledClassName="page-item disabled"
                  forcePage={this.state.page - 1}
                />
              )}
            </div>
          </div>
          {this.props.receivingReport.loading || this.props.vendorsList.loading ? <Spinner /> : null}
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    receivingReport: state.reports.receivingReport,
    vendorsList: state.invoices.vendorsList,
    currentUser: state.auth.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReceivingReport: (page, date, vendor, lot) => {
      dispatch(fetchReceivingReport(page, date, vendor, lot)).payload.then(
        (response) => {
          dispatch(fetchReceivingReportSuccess(response.data));
        },
        (error) => {
          dispatch(fetchReceivingReportFailure(error));
        }
      );
    },
    fetchVendors: () => {
      dispatch(fetchVendors()).payload.then(
        (response) => {
          dispatch(fetchVendorsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchVendorsFailure(error));
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportReceivingContainer));
